import { Hero } from './components/Hero';
import { LiveStatus } from './components/LiveStatus';
import { Services } from './components/Services';
import { SocialPlatforms } from './components/SocialPlatforms';
import { About } from './components/About';
import { FAQ } from './components/FAQ';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-rose-50/30 to-white">
      <Hero />
      <LiveStatus />
      <About />
      <Services />
      <SocialPlatforms />
      <FAQ />
      <CTA />
      <Footer />
    </div>
  );
}
